export default function TrustMarquee() {
  const items = [
    "LICENSED & INSURED",
    "100+ COMPLETED PROJECTS",
    "SAME-WEEK SCHEDULING",
    "CLEAN WORKMANSHIP",
    "HONEST PRICING",
    "RESIDENTIAL & COMMERCIAL",
    "SERVING LOS ANGELES",
  ];
  const row = [...items, ...items];
  return (
    <div data-testid="trust-marquee" className="border-y border-brand-line bg-brand-bone overflow-hidden">
      <div className="flex animate-marquee whitespace-nowrap py-4 gap-12">
        {row.map((t, i) => (
          <span key={i} className="text-xs font-bold tracking-[0.25em] text-brand-olive uppercase">
            {t} <span className="ml-12 text-brand-line">/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
